import TranslationHelper from '../../../helpers/TranslationHelper';

export default (key: string, defaultValue: string) =>
    TranslationHelper.translate('grid.' + key);
